module.exports = __webpack_public_path__ + "static/media/italy.612e617f.svg";